// Feed auto-refresh on return: decides whether coming back to the page
// (tab visible again / window focused) should trigger a silent in-place
// refresh of the feed. Kept pure so the thresholds can be unit tested
// without wiring up DOM visibility/focus events.
// Spec: docs/superpowers/specs/2026-08-06-feed-refresh-on-return-design.md

export const MIN_AWAY_MS = 60 * 1000;
export const MIN_REFRESH_INTERVAL_MS = 30 * 1000;

export function shouldRefreshOnReturn({
    hiddenAt,
    lastRefreshAt = 0,
    now,
    minAwayMs = MIN_AWAY_MS,
    minRefreshIntervalMs = MIN_REFRESH_INTERVAL_MS,
} = {}) {
    if (!hiddenAt || !now) {
        return false;
    }
    if (now - hiddenAt < minAwayMs) {
        return false;
    }
    if (lastRefreshAt && now - lastRefreshAt < minRefreshIntervalMs) {
        return false;
    }
    return true;
}
